/**
 * @module: 链接
 * @author: yuanxm
 * @date: 2020-01-03 12:01:07
 */

/**
 * 打开app
 *
 * @export
 * @param {string} [platform='default']
 * @param {string} [schema]
 * @param {string} [downUrl]
 */
export function openAPP(
  platform: string = 'default',
  schema?: string,
  downUrl?: string,
  goUpload?: boolean // 直接去下载
) {
  /**
   * 唤起定时器
   */
  let timer: any = null;
  let ua = navigator.userAgent;

  console.log(JSON.stringify({ platform, schema, downUrl }));

  const clearTimerTimeout = () => {
    console.log('clear timer ', timer);
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  /**
   * 客户端判断
   */
  const _browser = (function () {
    const _UA = ua.toLowerCase();
    return {
      //是否手机端
      isMobile: !!_UA.match(/AppleWebKit.*Mobile.*/i),
      // @ts-ignore
      //是否微信端
      isWX: _UA.match(/MicroMessenger/i) == 'micromessenger',
      // @ts-ignore
      //是否微博客户端
      isWB: _UA.match(/WeiBo/i) == 'weibo',
      // 是否是QQ内置浏览器
      isQQ:
        // @ts-ignore
        _UA.match(/QQ/i) == 'qq' && (_UA.indexOf('yyb_d') > -1 || _UA.indexOf('yybd') > -1),
      //是否iOS手机客户端
      isIOS: !!_UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i),
      //是否iOS平板
      isIOSHD: _UA.match(/ipad/i),
      // 是否三星手机
      // @ts-ignore
      isSamsung: _UA.match(/sm-/i) == 'sm-'
    };
  })();

  /**
   * 微信app内部方法
   */
  var wxUtil = {
    API: function (callback) {
      const win = window as any;
      win.WeixinJSBridge && win.WeixinJSBridge.invoke
        ? callback(win.WeixinJSBridge)
        : document.addEventListener(
            'WeixinJSBridgeReady',
            function () {
              callback(win.WeixinJSBridge);
            },
            false
          );
    },
    versionToNum: function (a) {
      var a = a.toString();
      var c = a.split('.');
      var maxVersion = 5;
      //最大版本区间5
      for (var i = c.length; i <= maxVersion; i++) {
        c[i] = '0';
      }
      return c.join('');
    },
    wxOpenApp: function (schemeUrl, callback) {
      wxUtil.API(function (bridge) {
        if (wxUtil.wxGreaterThan('6.5.5')) {
          bridge.invoke(
            'launchApplication',
            {
              schemeUrl: schemeUrl
            },
            function (e) {
              var errMsg = e.err_msg || e.errMsg || '';
              if (errMsg.indexOf('launchApplication:fail') > -1) {
                callback && callback();
              }
            }
          );
        }
      });
    },
    // a版本是否大于b版本
    greaterThan: function (a, b) {
      var _a = wxUtil.versionToNum(a);
      var _b = wxUtil.versionToNum(b);
      if (_a > _b) {
        return true;
      }
      return false;
    },
    // 当前版本是否大于a, 默认a为6.5.5
    wxGreaterThan: function (a) {
      var _a = a || '6.5.5';
      var wx = /MicroMessenger\/((\d+)\.(\d+)\.(\d+))/i;
      // @ts-ignore
      var version = ua.match(wx)[1];
      if (wxUtil.greaterThan(version, _a)) return true;
      return false;
    }
  };

  // 过滤掉javascript协议
  var _safeJump = function (link) {
    var safeLink = decodeURIComponent(link);
    if (!/^javascript/.test(safeLink)) {
      console.log('safe jump:', link);
      window.location.href = link;
    }
  };

  /**
   * 唤起app核心逻辑
   * @param {String} specMark 特殊处理, '[platform]-[sys]-[scheme]', 如'wzds-ios-douyutvkogMail',
   */
  var _chatApp = function (config) {
    var configByClient: any = null;

    console.log(JSON.stringify(_browser));
    if (goUpload) {
      window.location.href = config['ios']['downurl'];
    }
    // ios
    if (_browser.isIOS) {
      // IOS第三方渠道包下载地址
      configByClient = config['ios'];

      const iosDownUrl = downUrl || configByClient.downurl;
      const _schema = schema || configByClient.schema;

      // iosHD逻辑
      if (_browser.isIOSHD && configByClient['iosHD']) {
        configByClient = configByClient['iosHD'];
      }
      if (_browser.isWX && wxUtil.wxGreaterThan('6.5.5')) {
        // wxUtil.wxOpenApp(_schema, function() {
        // 失败回调，跳转下载地址
        _safeJump(iosDownUrl);
        // });
      } else {
        // 尝试唤起
        setTimeout(function () {
          console.log('jump:', _schema);
          window.location.href = _schema;
        }, 100);

        clearTimerTimeout();

        // 不管有没有唤起，3s后跳转下载页
        timer = setTimeout(function () {
          _safeJump(iosDownUrl);
        }, 3000);
      }
    } else {
      // Android下载地址
      configByClient = config['android'];

      const androidDownUrl = downUrl || configByClient.downurl;
      const _schema = schema || configByClient.schema;

      if (_browser.isWX && wxUtil.wxGreaterThan('6.5.5')) {
        // wxUtil.wxOpenApp(_schema, function() {
        // 失败回调，跳转下载地址
        _safeJump(androidDownUrl);
        // });
      } else {
        let ifr: HTMLIFrameElement;

        if (_browser.isSamsung) {
          setTimeout(function () {
            window.location.href = _schema;
          }, 100);
        } else {
          ifr = document.createElement('iframe');
          ifr.src = _schema;
          ifr.style.display = 'none';
          // 尝试唤起
          document.body.appendChild(ifr);
        }

        console.log('jump:', _schema);

        clearTimerTimeout();

        // 不管有没有唤起，3s后跳转下载页
        timer = setTimeout(function () {
          _safeJump(androidDownUrl);
          ifr && document.body.removeChild(ifr);
        }, 3000);
      }
    }
  };

  /**
   * scheme 配置
   */
  var _getSchemeByPlatform = function () {
    // scheme汇总
    var schemaConfigs = {
      default: {
        android: {
          schema: 'yunwoke://native',
          downurl: encodeURI('https://a.app.qq.com/o/simple.jsp?pkgname=com.yunzujia.tt')
        },
        ios: {
          schema: 'yunwoke://',
          downurl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.yunzujia.tt'
          // downurl: 'itms-apps://itunes.apple.com/cn/app/id1028355284?mt=8'
        }
      }
    };

    // 来自的平台（默认default）
    return schemaConfigs[platform] || schemaConfigs['default'];
  };

  // 唤起后尝试禁止下载（不兼容）
  const pageVisibility = (function () {
    let prefixSupport;
    const keyWithPrefix = function (prefix, key) {
      if (prefix !== '') {
        return prefix + key.slice(0, 1).toUpperCase() + key.slice(1);
      }
      return key;
    };
    const isPageVisibilitySupport = (function () {
      let support = false;
      if (typeof window.screenX === 'number') {
        ['webkit', 'moz', 'ms', 'o', ''].forEach(function (prefix) {
          console.log(
            'prefix:',
            prefix,
            document[keyWithPrefix(prefix, 'hidden')],
            document[keyWithPrefix(prefix, 'visibilitychange')]
          );
          if (support == false && document[keyWithPrefix(prefix, 'hidden')] != undefined) {
            prefixSupport = prefix;
            support = true;
            console.log('prefixSupport:', prefixSupport);
          }
        });
      }
      return support;
    })();

    const isHidden = function () {
      if (isPageVisibilitySupport) {
        return document[keyWithPrefix(prefixSupport, 'hidden')];
      }
      return undefined;
    };

    const visibilityState = function () {
      if (isPageVisibilitySupport) {
        return document[keyWithPrefix(prefixSupport, 'visibilityState')];
      }
      return undefined;
    };

    return {
      hidden: isHidden(),
      visibilityState: visibilityState(),
      visibilitychange: function (fn, usecapture) {
        usecapture = undefined || false;
        if (isPageVisibilitySupport && typeof fn === 'function') {
          const eventFn = evt => {
            console.log('visibilitychange');
            // @ts-ignore
            this.hidden = isHidden();
            // @ts-ignore
            this.visibilityState = visibilityState();
            // @ts-ignore
            fn.call(this, evt);

            document.removeEventListener(prefixSupport + 'visibilitychange', eventFn, usecapture);
          };

          return document.addEventListener(prefixSupport + 'visibilitychange', eventFn, usecapture);
        }
        return undefined;
      }
    };
    // @ts-ignore
  })(undefined);

  pageVisibility.visibilitychange(clearTimerTimeout, true);

  // iOS safari上弹出是否打开应用的系统提示后选择打开，
  // 切换到云沃客应用不会触发visibilityChange事件
  // 所以通过定时器处理
  let i = 0;
  const interval = setInterval(() => {
    i++;
    if (i > 30) {
      clearInterval(interval);
    }
    if (document.hidden) {
      console.log('document hidden');
      clearTimerTimeout();
    }
  }, 100);

  /**
   * 直接使用地址上的参数（通用方法）
   */
  function openBySearch() {
    _chatApp(_getSchemeByPlatform());
  }

  openBySearch();
}
